// src/main.js - ShadowTrace SDK（完整版，已修改 session 30min 无活动过期 + 归因/加密跟随重置）

// 立即占位防止按钮报错
const isInIframe = window.self !== window.top;

window.initUserBehaviorSDK = function () {};
window.optOutUserBehaviorSDK = function () {};
window.optInUserBehaviorSDK = function () {};
window.trackEvent = function () {};
window.setABTest = function () {};
window.forceSendSDKData = function () {};
window.safeInitShadowTrace = function () {};
let _sdkInitialized = false;

(function () {
  // ==================== 机器人检测 ====================
  let botDetectionResult = null; // { bot: boolean, botKind: string|null, botProbability: number, ... }
  const BOT_DETECTION_ENABLED = true; // 可通过 options 控制

  // ==================== 配置常量 ====================
  const DEBUG_MODE = true;
  const LOG_PAGE_DIMENSIONS = true;

  // ==================== session & 过期配置 ====================
  const SESSION_EXPIRY_MINUTES = 30;
  const SESSION_INACTIVITY_TIMEOUT_MS = SESSION_EXPIRY_MINUTES * 60 * 1000;
  const STORAGE_KEY_LAST_ACTIVE = 'shadowtrace_last_active'; // 最后活跃时间戳

  // ==================== 加密配置 ====================
  const ENCRYPTION_ENABLED = true;
  const DEFAULT_ENCRYPTION_ALGORITHM = 'RSA-AES256-CBC';

  // ==================== API端点配置 ====================
  const API_ENDPOINTS = {
    SESSION_CREATE: '/api/encryption/session/create',
    IP_INFO: '/api/encryption/session/getIPInfo',
    PUBLIC_KEY: '/api/encryption/public-key',
    SAVE_DATA: '/api/encryption/save'
  };

  // ==================== 存储键名 ====================
  const STORAGE_KEY_SESSION = 'shadowtrace_session_id';
  const STORAGE_KEY_ENCRYPTION = 'shadowtrace_encryption_data';
  const STORAGE_KEY_APP_ID = 'shadowtrace_app_id';
  const STORAGE_KEY_CORE_WEB_VITALS = 'shadowtrace_core_web_vitals';
  const STORAGE_KEY_ATTRIBUTION = 'shadowtrace_attribution';
  const STORAGE_KEY_COUNTRY = 'shadowtrace_country_info'; // 缓存 24 小时

  // ==================== 自动初始化配置 ====================
  const AUTO_INIT = true;
  const AUTO_INIT_CONFIG = {
    serverUrl: 'https://shadowtrace.yingdl.com',
    // serverUrl: 'https://localhost:7027',
    gridRows: 80,
    gridCols: 160,
    encryptionEnabled: true
  };
  const INIT_DELAY = 1000;

  // ==================== 私有变量 ====================
  let totalVisibleTime = 0;
  let lastVisibleTime = performance.now();

  let clickGrid = {};
  let moveGrid = {};
  let maxScrollDepth = 0;
  let rageClicks = [];

  let pvCount = 0;
  let paths = [];
  let totalClicks = 0;
  let customEvents = [];

  let rapidClicks = 0;
  let linearMoves = 0;

  let gridRows = 80;
  let gridCols = 160;
  let serverUrl = null;
  let sessionId = null;
  let appId = null;
  let isRunning = false;
  let encryptionEnabled = ENCRYPTION_ENABLED;

  // ==================== 国家信息 ====================
  let countryInfo = {
    countryCode: null,
    countryName: null,
    region: null,
    city: null,
    latitude: null,
    longitude: null,
    fetched: false
  };

  // 加密相关变量
  let encryptionInfo = {
    sessionId: null,
    encryptedAesKey: null,
    aesIv: null,
    rsaPublicKey: null,
    aesKey: null,
    cryptoKey: null,
    sessionExpiry: 0,
    algorithm: DEFAULT_ENCRYPTION_ALGORITHM
  };

  let lastClickTime = 0;
  let lastClickGridKey = null;
  let rageThresholdCount = 3;
  let rageThresholdMs = 800;

  let lastMoveTime = 0;
  let moveThrottleMs = 150;
  let lastMoveX = null;
  let lastMoveY = null;

  let baseInfoSent = false;
  let baseInfo = {};

  let abTestInfo = { experimentId: null, variant: null, version: null };

  const eventQueue = [];
  let batchInterval = null;
  let resizeTimeout = null;

  // ==================== Core Web Vitals 相关变量 ====================
  let lcpValue = 0;
  let lcpElement = null;
  let lcpUrl = '';
  let lcpReported = false;

  let clsValue = 0;
  let clsSessionValue = 0;
  let clsEntries = [];
  let clsObserver = null;
  let clsReported = false;

  let inpValue = 0;
  let inpEntries = [];
  let inpStartTime = 0;
  let inpReported = false;

  let fidValue = 0;
  let fidEntries = [];
  let fidReported = false;

  let pageLoadTiming = {};
  let pageLoadEntries = [];

  // ==================== 渠道归因信息 ====================
  let attributionInfo = {
    source: '(not set)',
    medium: '(not set)',
    campaign: '(not set)',
    content: null,
    term: null,
    channel: 'direct',
    sourceType: '(direct)',
    socialPlatform: null,
    referrerDomain: null,
    isFirstVisit: true
  };

  const SOCIAL_PLATFORMS = {
    'facebook.com': 'facebook', 'fb.com': 'facebook', 'fb.me': 'facebook',
    'm.facebook.com': 'facebook', 'l.facebook.com': 'facebook',
    'instagram.com': 'instagram', 'www.instagram.com': 'instagram',
    'tiktok.com': 'tiktok', 'www.tiktok.com': 'tiktok',
    'youtube.com': 'youtube', 'youtu.be': 'youtube', 'm.youtube.com': 'youtube',
    'twitter.com': 'x', 'x.com': 'x', 't.co': 'x',
    'linkedin.com': 'linkedin', 'lnkd.in': 'linkedin',
    'pinterest.com': 'pinterest', 'pin.it': 'pinterest',
    'reddit.com': 'reddit', 'old.reddit.com': 'reddit',
    'whatsapp.com': 'whatsapp', 'wa.me': 'whatsapp',
    'wechat.com': 'wechat',
    'threads.net': 'threads',
    'bsky.app': 'bluesky', 'bsky.social': 'bluesky',
    'snapchat.com': 'snapchat'
  };

  // ==================== 辅助函数 ====================
  function isNullOrEmpty(value) {
    return value === null || value === undefined || value === '';
  }

  function isNullOrWhiteSpace(value) {
    if (isNullOrEmpty(value)) return true;
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value.trim() === '';
  }

  // ==================== session 管理（带 30min 无活动过期） ====================
  function getPersistentSessionId() {
    const now = Date.now();

    let lastActive = null;
    try {
      const storedTime = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
      lastActive = storedTime ? parseInt(storedTime, 10) : null;
    } catch (e) {}

    let storedSessionId = null;
    try {
      storedSessionId = localStorage.getItem(STORAGE_KEY_SESSION);
    } catch (e) {}

    const isExpired = !lastActive || (now - lastActive > SESSION_INACTIVITY_TIMEOUT_MS);

    if (isExpired || !storedSessionId) {
      // 过期或首次 → 新 session + 重置归因 + 重置加密
      const newId = 'st_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);

      try {
        localStorage.setItem(STORAGE_KEY_SESSION, newId);
        localStorage.setItem(STORAGE_KEY_LAST_ACTIVE, now.toString());

        // 重置归因：让下次 init 时重新从 URL / referrer 计算
        localStorage.removeItem(STORAGE_KEY_ATTRIBUTION);

        // 重置加密 session
        clearEncryptionInfo();
      } catch (e) {
        console.warn('[Session] localStorage 操作失败，使用临时 ID');
      }

      return newId;
    } else {
      // 未过期 → 复用并刷新活跃时间
      try {
        localStorage.setItem(STORAGE_KEY_LAST_ACTIVE, now.toString());
      } catch (e) {}
      return storedSessionId;
    }
  }

  function updateLastActiveTime() {
    const now = Date.now();
    try {
      localStorage.setItem(STORAGE_KEY_LAST_ACTIVE, now.toString());
      
      // 同时更新加密会话的过期时间
      if (encryptionInfo.sessionExpiry) {
        // 加密会话过期时间也延后30分钟
        encryptionInfo.sessionExpiry = now + SESSION_INACTIVITY_TIMEOUT_MS;
        saveEncryptionInfoToStorage();
      }
    } catch (e) {}
  }

  // ==================== 渠道归因 ====================
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term'),
      utm_id: params.get('utm_id'),
      gclid: params.get('gclid'),
      fbclid: params.get('fbclid')
    };
  }

  function getSocialPlatformFromSource(source) {
    if (!source) return null;
    source = source.toLowerCase();
    if (source.includes('facebook') || source.includes('meta')) return 'facebook';
    if (source.includes('instagram')) return 'instagram';
    if (source.includes('tiktok')) return 'tiktok';
    if (source.includes('youtube')) return 'youtube';
    if (source.includes('twitter') || source.includes('x.com')) return 'x';
    if (source.includes('linkedin')) return 'linkedin';
    if (source.includes('pinterest')) return 'pinterest';
    if (source.includes('reddit')) return 'reddit';
    if (source.includes('snapchat')) return 'snapchat';
    if (source.includes('threads')) return 'threads';
    if (source.includes('bluesky')) return 'bluesky';
    return 'other-social';
  }

  function classifyChannel(params, referrerDomain) {
    const source = params.utm_source?.toLowerCase() || '';
    const medium = params.utm_medium?.toLowerCase() || '';
    const referrer = referrerDomain ? referrerDomain.toLowerCase().replace(/^www\./, '') : null;

    if (referrer) {
      if (
        referrer.includes('google') ||
        referrer.match(/google\.(com|co|co\.uk|ca|de|fr|com\.br|co\.jp|com\.au|co\.in|cn|ru|it|nl|es|se|no|dk|fi|pl|be|ch|at|cz|hu|gr|ie|pt|tr|ua|ar|cl|mx|co|pe|vn|id|th|my|ph|sg|nz|in)/) ||
        referrer.includes('bing.com') ||
        referrer.includes('baidu.com') ||
        referrer.includes('yahoo.com') ||
        referrer.includes('duckduckgo.com') ||
        referrer.includes('yandex.com') ||
        referrer.includes('naver.com') ||
        referrer.includes('ecosia.org') ||
        referrer.includes('qwant.com')
      ) {
        return { channel: 'organic-search', sourceType: referrerDomain || 'search-engine', socialPlatform: null };
      }

      for (const domain in SOCIAL_PLATFORMS) {
        if (referrer.includes(domain)) {
          const platform = SOCIAL_PLATFORMS[domain];
          return { channel: 'organic-social', sourceType: platform, socialPlatform: platform };
        }
      }

      return { channel: 'referral', sourceType: referrerDomain, socialPlatform: null };
    }

    if (params.gclid || (source.includes('google') && (medium.includes('cpc') || medium.includes('ppc')))) {
      return { channel: 'paid-search', sourceType: 'google', socialPlatform: null };
    }

    if (
      params.fbclid ||
      source.includes('facebook') ||
      source.includes('meta') ||
      source.includes('instagram') ||
      source.includes('tiktok') ||
      medium.includes('paid-social') ||
      medium.includes('social-paid') ||
      (medium.includes('social') && (source.includes('facebook') || source.includes('instagram') || source.includes('tiktok')))
    ) {
      const socialPlatform = getSocialPlatformFromSource(source) || 'meta-family';
      return { channel: 'paid-social', sourceType: source || 'meta-family', socialPlatform };
    }

    if (medium.includes('cpc') || medium.includes('ppc') || medium.includes('paid') || medium.includes('cpm')) {
      return { channel: 'paid', sourceType: source || '(paid)', socialPlatform: null };
    }

    if (source && medium) {
      if (medium.includes('social') || medium.includes('organic-social')) {
        const socialPlatform = getSocialPlatformFromSource(source);
        return { channel: 'organic-social', sourceType: source, socialPlatform: socialPlatform || 'social' };
      }
      if (medium === 'email' || medium === 'newsletter' || medium.includes('eml')) {
        return { channel: 'email', sourceType: source || 'email' };
      }
      if (medium === 'affiliate' || medium.includes('aff')) {
        return { channel: 'affiliate', sourceType: source || 'affiliate' };
      }
      return { channel: 'organic-other', sourceType: source, socialPlatform: null };
    }

    return { channel: 'direct', sourceType: '(direct)', socialPlatform: null };
  }
  // ==================== 尝试从 referrer 或 URL 获取搜索关键词 ====================
  function extractSearchKeyword() {
    // 优先级 1: 当前页面 URL 中的 utm_term（广告/带参链接，最可靠，Google Ads / 百度推广 等）
    const params = getUrlParams();  // 已有的函数，直接复用
    if (params.utm_term && !isNullOrWhiteSpace(params.utm_term)) {
      const term = decodeURIComponent(params.utm_term.trim());
      if (term.length > 1) {  // 避免空或单个字符
        return term;
      }
    }

    // 优先级 2: referrer 中的搜索引擎参数（2026年成功率很低，Google ≈0%，国内部分还有）
    const referrer = document.referrer;
    if (!referrer || referrer === '') return null;

    try {
      const refUrl = new URL(referrer);
      const hostname = refUrl.hostname.toLowerCase();
      const refParams = new URLSearchParams(refUrl.search);

      // 百度（PC部分流量、老浏览器/渠道仍有 wd / word）
      if (hostname.includes('baidu.com') || hostname.includes('baidu')) {
        const wd = refParams.get('wd') || refParams.get('word');
        if (wd) return decodeURIComponent(wd.trim());
      }

      // 360搜索（so.com / 360.cn，相对较多还带 q）
      if (hostname.includes('so.com') || hostname.includes('360.cn') || hostname.includes('qihoo')) {
        const q = refParams.get('q');
        if (q) return decodeURIComponent(q.trim());
      }

      // 搜狗（sogou.com，部分微信/老流量仍有 keyword 或 q）
      if (hostname.includes('sogou.com') || hostname.includes('sogou')) {
        const keyword = refParams.get('keyword') || refParams.get('q');
        if (keyword) return decodeURIComponent(keyword.trim());
      }

      // 神马 / 其他国内小引擎（极少）
      if (hostname.includes('sm.cn')) {
        const q = refParams.get('q');
        if (q) return decodeURIComponent(q.trim());
      }

      // Google / Bing / Yahoo 等（2026年基本全加密，永远拿不到 q）
      // 可以留空或记录日志，但实际返回 null
      return null;
    } catch (e) {
      console.warn('[关键词提取] referrer 解析失败:', e.message);
      return null;
    }
  }

  function loadAttribution() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_ATTRIBUTION);
      if (stored) {
        attributionInfo = JSON.parse(stored);
        attributionInfo.isFirstVisit = false;
        return true;
      }
    } catch (e) { console.warn('[归因] 加载失败', e); }
    return false;
  }

  function saveAttribution() {
    try {
      localStorage.setItem(STORAGE_KEY_ATTRIBUTION, JSON.stringify(attributionInfo));
    } catch (e) { console.warn('[归因] 保存失败', e); }
  }

  // ==================== 获取国家信息 ====================
  async function fetchCountryInfo() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_COUNTRY);
      if (stored) {
        const data = JSON.parse(stored);
        if (Date.now() - data.timestamp < 24 * 60 * 60 * 1000) {
          countryInfo = { ...data.info, fetched: true };
          return;
        }
      }
    } catch (e) {}

    try {
      const response = await fetch(`${serverUrl}${API_ENDPOINTS.IP_INFO}`);
      if (!response.ok) throw new Error(`ipapi.co 响应异常: ${response.status}`);
      const data = await response.json();
      if (data.error) throw new Error(data.reason || '未知错误');

      countryInfo = {
        countryCode: data.country_code || null,
        countryName: data.country_name || null,
        region: data.region || null,
        city: data.city || null,
        latitude: data.latitude || null,
        longitude: data.longitude || null,
        fetched: true
      };

      localStorage.setItem(STORAGE_KEY_COUNTRY, JSON.stringify({
        timestamp: Date.now(),
        info: countryInfo
      }));
    } catch (error) {
      console.warn('[国家] 获取失败:', error.message);
      countryInfo = { countryCode: null, countryName: '未知', region: null, city: null, fetched: false };
    }
  }

  // ==================== 机器人检测 ====================
  async function detectBot() {
    if (!BOT_DETECTION_ENABLED) return;
    try {
      const { load } = await import('https://cdn.jsdelivr.net/npm/@fingerprintjs/botd@2/dist/botd.esm.min.js');
      const botd = await load();
      const result = await botd.detect();
      botDetectionResult = {
        bot: result.bot,
        botKind: result.botKind || null,
        botProbability: result.botProbability || 0,
        detectionTime: Date.now()
      };
    } catch (error) {
      console.error('[BotD] 加载/检测失败:', error);
      botDetectionResult = { bot: false, botKind: 'error', botProbability: 0 };
    }
  }

  // ==================== 加密相关函数（保持原样，仅在 session 过期时被 clear） ====================
  function base64ToArrayBuffer(base64) {
    try {
      if (isNullOrWhiteSpace(base64)) throw new Error('Base64字符串为空');
      const cleanBase64 = cleanBase64String(base64);
      const binary = atob(cleanBase64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes.buffer;
    } catch (error) {
      console.error('[加密] Base64转ArrayBuffer失败:', error);
      throw error;
    }
  }

  function arrayBufferToBase64(buffer) {
    try {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        let base64 = btoa(binary);
        
        // 移除换行（btoa通常不会添加）
        base64 = base64.replace(/[\r\n]/g, '');
        
        // 不要手动添加padding，让自然状态传递
        // 只有在长度不是4的倍数且需要传输时才考虑
        
        return base64;
    } catch (error) {
        console.error('[Base64] 生成失败:', error);
        throw error;
    }
}

  // function cleanBase64String(base64) {
  //   if (isNullOrWhiteSpace(base64)) return base64;
  //   let cleaned = base64.replace(/\r/g, '').replace(/\n/g, '').replace(/ /g, '').replace(/\t/g, '').trim();
  //   cleaned = cleaned.replace(/_/g, '/').replace(/-/g, '+');
  //   cleaned = cleaned.replace(/[^A-Za-z0-9+/=]/g, '');
  //   const remainder = cleaned.length % 4;
  //   if (remainder !== 0) {
  //     cleaned += '='.repeat(4 - remainder);
  //   }
  //   return cleaned;
  // }
  function cleanBase64String(base64) {
    if (!base64 || typeof base64 !== 'string') return base64 || '';
    
    // 只移除真正有害的字符，不删 = 
    let cleaned = base64
      .replace(/[\r\n\t ]/g, '')     // 只去换行、回车、tab、空格
      .trim();
    
    // 不要替换 _- 到 +/ ，除非你明确知道数据来源是 url-safe base64
    // cleaned = cleaned.replace(/_/g, '/').replace(/-/g, '+');  ← 注释掉这一行
    
    // 不要再 replace [^A-Za-z0-9+/=] ，太危险，会删掉合法字符
    
    return cleaned;
  }

  function isValidBase64(base64) {
    if (isNullOrEmpty(base64)) return false;
    try {
      const cleaned = cleanBase64String(base64);
      atob(cleaned);
      return true;
    } catch {
      return false;
    }
  }

  async function importRsaPublicKey(publicKeyBase64) {
    try {
      const cleanedKey = cleanBase64String(publicKeyBase64);
      const binary = base64ToArrayBuffer(cleanedKey);
      return await window.crypto.subtle.importKey(
        "spki",
        binary,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"]
      );
    } catch (error) {
      console.error('[加密] 导入RSA公钥失败:', error);
      throw error;
    }
  }

  async function importAesKey(keyBase64, ivBase64) {
    try {
      const cleanedKey = cleanBase64String(keyBase64);
      const cleanedIv = cleanBase64String(ivBase64);
      const keyBytes = base64ToArrayBuffer(cleanedKey);
      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        keyBytes,
        { name: 'AES-CBC' },
        false,
        ['encrypt']
      );
      return { cryptoKey, key: cleanedKey, iv: cleanedIv };
    } catch (error) {
      console.error('[加密] 导入AES密钥失败:', error);
      throw error;
    }
  }

  async function generateAesKey() {
    try {
      const key = await window.crypto.subtle.generateKey(
        { name: 'AES-CBC', length: 256 },
        true,
        ['encrypt', 'decrypt']
      );
      const exported = await window.crypto.subtle.exportKey('raw', key);
      const aesKey = arrayBufferToBase64(exported);
      const iv = window.crypto.getRandomValues(new Uint8Array(16));
      const aesIv = arrayBufferToBase64(iv);
      return { key: aesKey, iv: aesIv, cryptoKey: key };
    } catch (error) {
      console.error('[加密] 生成AES密钥失败:', error);
      throw error;
    }
  }

  function saveEncryptionInfoToStorage() {
    try {
      const encryptionData = {
        sessionId: encryptionInfo.sessionId,
        encryptedAesKey: encryptionInfo.encryptedAesKey,
        aesIv: encryptionInfo.aesIv,
        rsaPublicKey: encryptionInfo.rsaPublicKey,
        aesKey: encryptionInfo.aesKey,
        sessionExpiry: encryptionInfo.sessionExpiry,
        timestamp: Date.now(),
        appId: appId,
        algorithm: encryptionInfo.algorithm
      };
      localStorage.setItem(STORAGE_KEY_ENCRYPTION, JSON.stringify(encryptionData));
    } catch (error) {
      console.warn('[加密] 保存加密信息失败:', error);
    }
  }

  function loadEncryptionInfoFromStorage() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY_ENCRYPTION);
      if (!stored) return false;
      
      const encryptionData = JSON.parse(stored);
      
      // 检查appId是否匹配
      if (encryptionData.appId && appId && encryptionData.appId !== appId) {
        localStorage.removeItem(STORAGE_KEY_ENCRYPTION);
        return false;
      }
      
      // 检查会话是否已过期（关键修复！）
      if (encryptionData.sessionExpiry && encryptionData.sessionExpiry <= Date.now()) {
        console.log('[加密] 存储的会话已过期，清除');
        localStorage.removeItem(STORAGE_KEY_ENCRYPTION);
        return false;
      }
      
      // 赋值
      encryptionInfo.sessionId = encryptionData.sessionId;
      encryptionInfo.encryptedAesKey = encryptionData.encryptedAesKey;
      encryptionInfo.aesIv = encryptionData.aesIv;
      encryptionInfo.rsaPublicKey = encryptionData.rsaPublicKey;
      encryptionInfo.aesKey = encryptionData.aesKey;
      encryptionInfo.sessionExpiry = encryptionData.sessionExpiry || 0;
      encryptionInfo.algorithm = encryptionData.algorithm || DEFAULT_ENCRYPTION_ALGORITHM;
      
      // 如果AES密钥和IV都存在，导入到cryptoKey
      if (encryptionInfo.aesKey && encryptionInfo.aesIv) {
        return importAesKey(encryptionInfo.aesKey, encryptionInfo.aesIv)
          .then(aesData => {
            encryptionInfo.cryptoKey = aesData.cryptoKey;
            return true;
          })
          .catch(() => {
            console.warn('[加密] 导入AES密钥失败');
            return false;
          });
      }
      
      return false;
    } catch (error) {
      console.warn('[加密] 加载加密信息失败:', error);
      return false;
    }
  }

  function clearEncryptionInfo() {
    encryptionInfo = {
      sessionId: null,
      encryptedAesKey: null,
      aesIv: null,
      rsaPublicKey: null,
      aesKey: null,
      cryptoKey: null,
      sessionExpiry: 0,
      algorithm: DEFAULT_ENCRYPTION_ALGORITHM
    };
    try {
      localStorage.removeItem(STORAGE_KEY_ENCRYPTION);
    } catch (e) {}
  }

  function isEncryptionSessionValid() {
    // 1. 检查基本字段是否存在
    if (!encryptionInfo.sessionId || !encryptionInfo.aesKey || !encryptionInfo.cryptoKey) {
      console.log('[加密] 基本字段缺失');
      return false;
    }
    
    // 2. 检查加密会话过期时间
    const now = Date.now();
    if (encryptionInfo.sessionExpiry && encryptionInfo.sessionExpiry <= now) {
      console.log('[加密] 会话已过期');
      return false;
    }
    
    // 3. 检查主会话是否过期（关键！加密会话应该跟随主会话）
    const lastActive = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
    if (!lastActive || (now - parseInt(lastActive, 10) > SESSION_INACTIVITY_TIMEOUT_MS)) {
      console.log('[加密] 主会话已过期，加密会话也失效');
      return false;
    }
    
    return true;
  }

  // ==================== 修改 ensureEncryptionSession ====================
  async function ensureEncryptionSession(options, forceNew = false) {
    if (!options.appId) {
      console.error('[加密] 缺少 appId');
      return false;
    }
    
    appId = options.appId;
    
    try {
      // 检查主会话是否过期
      const lastActive = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
      const now = Date.now();
      
      if (!lastActive || (now - parseInt(lastActive, 10) > SESSION_INACTIVITY_TIMEOUT_MS)) {
        console.log('[加密] 主会话已过期，需要新的主会话和加密会话');
        // 先获取新的主会话ID
        sessionId = getPersistentSessionId(); // 这会创建新session并重置加密
        forceNew = true;
      }
      
      // 如果不是强制创建新会话，先检查本地存储
      if (!forceNew) {
        const hasLocalSession = await loadEncryptionInfoFromStorage();
        
        if (hasLocalSession && isEncryptionSessionValid()) {
          console.log('[加密] 使用有效本地加密会话');
          encryptionEnabled = true;
          return true;
        }
      }
      
      // 创建新加密会话
      console.log('[加密] 创建新加密会话');
      
      // 确保有主 sessionId
      if (!sessionId) {
        sessionId = getPersistentSessionId();
      }
      
      const created = await createEncryptionSession(appId, sessionId);
      
      if (created) {
        // 设置加密会话过期时间（与主会话保持一致）
        const lastActiveTime = parseInt(localStorage.getItem(STORAGE_KEY_LAST_ACTIVE) || Date.now().toString(), 10);
        encryptionInfo.sessionExpiry = lastActiveTime + SESSION_INACTIVITY_TIMEOUT_MS;
        saveEncryptionInfoToStorage();
        
        console.log('[加密] 加密会话创建成功，有效期至:', 
          new Date(encryptionInfo.sessionExpiry).toLocaleTimeString());
        encryptionEnabled = true;
        return true;
      } else {
        throw new Error('创建加密会话失败');
      }
    } catch (error) {
      console.error('[加密] 确保加密会话失败:', error);
      clearEncryptionInfo();
      encryptionEnabled = false;
      return false;
    }
  }

  async function encryptData(plaintext) {
    if (!isEncryptionSessionValid()) {
        throw new Error('加密会话无效或已过期');
    }
  
    try {
        const encoder = new TextEncoder();
        const encoded = encoder.encode(plaintext);
  
        const ivArray = base64ToArrayBuffer(encryptionInfo.aesIv);
  
        const encrypted = await window.crypto.subtle.encrypt(
            { name: 'AES-CBC', iv: ivArray },
            encryptionInfo.cryptoKey,
            encoded
        );
  
        // 生成Base64
        let encryptedBase64 = arrayBufferToBase64(encrypted);
        
        console.log('[加密] 原始encryptedBase64:', {
            length: encryptedBase64.length,
            first50: encryptedBase64.substring(0, 50),
            last50: encryptedBase64.substring(Math.max(0, encryptedBase64.length - 50)),
            hasEquals: encryptedBase64.includes('='),
            equalsCount: (encryptedBase64.match(/=/g) || []).length
        });

        // 验证Base64格式
        try {
            // 测试解码前100个字符
            const testStr = encryptedBase64.substring(0, Math.min(100, encryptedBase64.length));
            atob(testStr);
            console.log('[加密] Base64自检通过');
        } catch (e) {
            console.error('[加密] Base64自检失败:', e.message);
            
            // 尝试修复：移除非法字符
            encryptedBase64 = encryptedBase64.replace(/[^A-Za-z0-9+/=]/g, '');
            console.log('[加密] 修复后Base64长度:', encryptedBase64.length);
        }

        return encryptedBase64;
    } catch (error) {
        console.error('[加密] AES加密数据失败:', error);
        throw error;
    }
}

// ==================== 加密会话管理增强 ====================
function isEncryptionSessionValid() {
  // 1. 检查基本字段是否存在
  if (!encryptionInfo.sessionId || !encryptionInfo.aesKey || !encryptionInfo.cryptoKey) {
    console.log('[加密] 基本字段缺失');
    return false;
  }
  
  // 2. 检查过期时间（重要！）
  const now = Date.now();
  if (encryptionInfo.sessionExpiry && encryptionInfo.sessionExpiry <= now) {
    console.log('[加密] 会话已过期，过期时间:', new Date(encryptionInfo.sessionExpiry).toISOString());
    return false;
  }
  
  // 3. 检查是否即将过期（15分钟内），提前续期
  if (encryptionInfo.sessionExpiry && (encryptionInfo.sessionExpiry - now) < (15 * 60 * 1000)) {
    console.log('[加密] 会话即将过期，需要续期');
    return false; // 标记为无效，触发重新创建
  }
  
  return true;
}

async function ensureEncryptionSession(options) {
  if (!options.appId) {
    console.error('[加密] 缺少 appId');
    return false;
  }
  
  appId = options.appId;
  
  try {
    // 先检查本地存储是否有会话
    const hasLocalSession = await loadEncryptionInfoFromStorage();
    
    if (hasLocalSession && isEncryptionSessionValid()) {
      console.log('[加密] 使用有效本地加密会话，剩余时间:', 
        Math.round((encryptionInfo.sessionExpiry - Date.now()) / 60000), '分钟');
      encryptionEnabled = true;
      return true;
    }
    
    // 会话无效或即将过期，创建新会话
    console.log('[加密] 创建/续期加密会话');
    
    // 在创建新会话前，先获取主 sessionId
    if (!sessionId) {
      sessionId = getPersistentSessionId();
    }
    
    const created = await createEncryptionSession(appId, sessionId);
    
    if (created) {
      // 更新本地存储的过期时间（30分钟后）
      encryptionInfo.sessionExpiry = Date.now() + (30 * 60 * 1000);
      saveEncryptionInfoToStorage();
      
      console.log('[加密] 加密会话创建成功，新sessionId:', encryptionInfo.sessionId);
      encryptionEnabled = true;
      return true;
    } else {
      throw new Error('创建加密会话失败');
    }
  } catch (error) {
    console.error('[加密] 确保加密会话失败:', error);
    clearEncryptionInfo();
    encryptionEnabled = false;
    return false;
  }
}

// ==================== 修改 loadEncryptionInfoFromStorage ====================
function loadEncryptionInfoFromStorage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_ENCRYPTION);
    if (!stored) return false;
    
    const encryptionData = JSON.parse(stored);
    
    // 检查appId是否匹配
    if (encryptionData.appId && appId && encryptionData.appId !== appId) {
      localStorage.removeItem(STORAGE_KEY_ENCRYPTION);
      return false;
    }
    
    // 检查会话是否已过期（关键修复！）
    if (encryptionData.sessionExpiry && encryptionData.sessionExpiry <= Date.now()) {
      console.log('[加密] 存储的会话已过期，清除');
      localStorage.removeItem(STORAGE_KEY_ENCRYPTION);
      return false;
    }
    
    // 赋值
    encryptionInfo.sessionId = encryptionData.sessionId;
    encryptionInfo.encryptedAesKey = encryptionData.encryptedAesKey;
    encryptionInfo.aesIv = encryptionData.aesIv;
    encryptionInfo.rsaPublicKey = encryptionData.rsaPublicKey;
    encryptionInfo.aesKey = encryptionData.aesKey;
    encryptionInfo.sessionExpiry = encryptionData.sessionExpiry || 0;
    encryptionInfo.algorithm = encryptionData.algorithm || DEFAULT_ENCRYPTION_ALGORITHM;
    
    // 如果AES密钥和IV都存在，导入到cryptoKey
    if (encryptionInfo.aesKey && encryptionInfo.aesIv) {
      return importAesKey(encryptionInfo.aesKey, encryptionInfo.aesIv)
        .then(aesData => {
          encryptionInfo.cryptoKey = aesData.cryptoKey;
          return true;
        })
        .catch(() => {
          console.warn('[加密] 导入AES密钥失败');
          return false;
        });
    }
    
    return false;
  } catch (error) {
    console.warn('[加密] 加载加密信息失败:', error);
    return false;
  }
}

// ==================== 添加加密会话健康检查函数 ====================
function startEncryptionHealthCheck() {
  // 每5分钟检查一次加密会话
  if (window._encryptionHealthCheckInterval) {
    clearInterval(window._encryptionHealthCheckInterval);
  }
  
  window._encryptionHealthCheckInterval = setInterval(() => {
    if (!isRunning || !encryptionEnabled) return;
    
    // 检查主会话是否即将过期
    const lastActive = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
    if (!lastActive) return;
    
    const now = Date.now();
    const lastActiveTime = parseInt(lastActive, 10);
    const timeSinceLastActive = now - lastActiveTime;
    const timeRemaining = SESSION_INACTIVITY_TIMEOUT_MS - timeSinceLastActive;
    
    // 如果主会话即将过期（5分钟内），不续期加密会话
    if (timeRemaining < 5 * 60 * 1000) {
      console.log('[健康检查] 主会话即将过期，不续期加密会话');
      return;
    }
    
    // 检查加密会话是否需要续期
    if (!isEncryptionSessionValid()) {
      console.log('[健康检查] 加密会话无效，准备更新');
      ensureEncryptionSession({ appId: appId }, true) // 强制创建新会话
        .then(success => {
          if (success) {
            console.log('[健康检查] 加密会话更新成功');
          } else {
            console.warn('[健康检查] 加密会话更新失败');
          }
        })
        .catch(err => {
          console.error('[健康检查] 检查加密会话时出错:', err);
        });
    }
  }, 5 * 60 * 1000); // 5分钟
}

// ==================== 修改 sendEvents 函数 ====================
async function sendEvents() {
  if (!isRunning || !serverUrl) return;
  
  // ===== 关键：每次发送前检查加密会话 =====
  if (encryptionEnabled) {
    try {
      if (!isEncryptionSessionValid()) {
        console.warn('[加密] 加密会话无效，尝试重新创建');
        const refreshed = await ensureEncryptionSession({ appId: appId });
        if (!refreshed) {
          console.warn('[加密] 无法恢复加密会话，本次发送使用明文');
          encryptionEnabled = false;
        }
      }
    } catch (error) {
      console.error('[加密] 会话检查失败:', error);
    }
  }
  
  // 构建和发送数据
  const lastIncrement = buildCurrentIncrement();
  const eventsToSend = [...eventQueue];
  if (lastIncrement) eventsToSend.push(lastIncrement);
  
  if (eventsToSend.length === 0) return;
  
  const payload = {
    events: eventsToSend,
    appId: appId,
    sdkVersion: '3.0.0',
    timestamp: Date.now()
  };
  
  eventQueue.length = 0;
  
  const encryptedData = await encryptDataForTransmission(payload);
  
  try {
    const endpoint = `${serverUrl}${API_ENDPOINTS.SAVE_DATA}`;
    if (navigator.sendBeacon) {
      const blob = new Blob([encryptedData], { type: 'application/json' });
      navigator.sendBeacon(endpoint, blob);
    } else {
      await fetch(endpoint, {
        method: 'POST',
        body: encryptedData,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      });
    }
  } catch (error) {
    console.error('[SDK] 发送失败:', error);
  }
}

// ==================== 修改 encryptDataForTransmission 添加详细日志 ====================
async function encryptDataForTransmission(data) {
  // 始终尝试使用加密，只要会话有效
  if (isEncryptionSessionValid()) {
    try {
      console.log('[加密] 使用会话加密:', {
        sessionId: encryptionInfo.sessionId,
        sessionExpiry: new Date(encryptionInfo.sessionExpiry).toISOString(),
        expiresIn: (encryptionInfo.sessionExpiry - Date.now()) / 1000 + '秒'
      });
      
      const jsonStr = JSON.stringify(data);
      console.log('[加密] 原始JSON长度:', jsonStr.length);

      const encryptedData = await encryptData(jsonStr);
      const cleanIv = encryptionInfo.aesIv.replace(/[\r\n\t ]/g, '').trim();

      console.log('[加密] 准备加密传输:', {
        encryptedDataLength: encryptedData.length,
        ivLength: cleanIv.length,
        sessionId: encryptionInfo.sessionId
      });

      const payload = {
        encrypted: true,
        version: '3.0',
        algorithm: encryptionInfo.algorithm,
        sessionId: encryptionInfo.sessionId,
        encryptedData: encryptedData,
        iv: cleanIv,
        appId: appId,
        timestamp: Date.now()
      };

      return JSON.stringify(payload);
    } catch (error) {
      console.error('[加密] 加密传输失败，降级为明文:', error);
      // 降级到明文
    }
  } else {
    console.warn('[加密] 加密会话无效，使用明文传输');
  }
  
  // 明文传输（加密不可用或失败）
  console.warn('[SDK] 使用明文传输');
  return JSON.stringify({
    SessionId: sessionId || 'unknown',
    EncryptedData: JSON.stringify(data),
    data: data,
    appId: appId,
    timestamp: Date.now()
  });
}

  async function fetchPublicKey(appId) {
    try {
      const response = await fetch(`${serverUrl}${API_ENDPOINTS.PUBLIC_KEY}?appId=${appId}`);
      if (!response.ok) throw new Error(`获取公钥失败: ${response.status}`);
      const responseData = await response.json();
      let data = responseData.data || responseData;
      if (!data.publicKey) throw new Error('服务器未返回公钥');
      encryptionInfo.rsaPublicKey = cleanBase64String(data.publicKey);
      return encryptionInfo.rsaPublicKey;
    } catch (error) {
      console.error('[加密] 获取RSA公钥失败:', error);
      throw error;
    }
  }

  async function createEncryptionSession(appId, clientSessionId = null) {
    try {
      const rsaPublicKey = await fetchPublicKey(appId);
      const aesKeyData = await generateAesKey();
      const encryptedAesKey = await rsaEncrypt(aesKeyData.key, rsaPublicKey);

      const payload = {
        appId: appId,
        clientSessionId: clientSessionId,
        encryptedAesKey: encryptedAesKey,
        aesIv: aesKeyData.iv
      };

      const response = await fetch(`${serverUrl}${API_ENDPOINTS.SESSION_CREATE}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error(`创建会话失败: ${response.status}`);
      const responseData = await response.json();
      let sessionInfo = responseData.data || responseData;

      if (responseData.code !== undefined && responseData.code !== 200) {
        throw new Error(`服务器错误: ${responseData.msg || '未知错误'}`);
      }
      if (sessionInfo.success === false) {
        throw new Error(sessionInfo.message || '创建加密会话失败');
      }

      encryptionInfo.sessionId = sessionInfo.sessionId;
      encryptionInfo.encryptedAesKey = cleanBase64String(sessionInfo.encryptedAesKey);
      encryptionInfo.aesIv = cleanBase64String(sessionInfo.aesIv);
      encryptionInfo.sessionExpiry = Date.now() + (SESSION_EXPIRY_MINUTES * 60 * 1000);
      encryptionInfo.aesKey = aesKeyData.key;
      encryptionInfo.cryptoKey = aesKeyData.cryptoKey;

      saveEncryptionInfoToStorage();
      return true;
    } catch (error) {
      console.error('[加密] 创建加密会话失败:', error);
      throw error;
    }
  }

  async function rsaEncrypt(plaintext, publicKeyBase64) {
    try {
      const cleanedPublicKey = cleanBase64String(publicKeyBase64);
      const publicKey = await importRsaPublicKey(cleanedPublicKey);
      const encoder = new TextEncoder();
      const encoded = encoder.encode(plaintext);
      const encrypted = await window.crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        publicKey,
        encoded
      );
      return arrayBufferToBase64(encrypted);
    } catch (error) {
      console.error('[加密] RSA加密失败:', error);
      throw error;
    }
  }

  async function initializeEncryption(options) {
    // 确保有 appId
    if (!options.appId) {
      console.error('[加密] 缺少 appId');
      encryptionEnabled = false;
      return false;
    }
    
    appId = options.appId;
    
    try {
      // 先尝试加载本地会话
      const hasValidLocalSession = await loadEncryptionInfoFromStorage();
      
      if (hasValidLocalSession && isEncryptionSessionValid()) {
        console.log('[加密] 加载到有效本地会话');
        encryptionEnabled = true;
        return true;
      }
      
      // 创建新会话
      console.log('[加密] 创建新加密会话');
      const created = await createEncryptionSession(appId, sessionId);
      
      if (created) {
        encryptionEnabled = true;
        console.log('[加密] 加密会话创建成功');
        return true;
      } else {
        throw new Error('创建加密会话失败');
      }
    } catch (error) {
      console.error('[加密] 初始化失败，禁用加密:', error);
      encryptionEnabled = false;
      clearEncryptionInfo();
      return false;
    }
  }
  // ==================== 应用ID ====================
  function getAppId(options = {}) {
    let id = null;
  
    // 优先级1: options
    if (options.appId && options.appId.trim()) {
      id = options.appId.trim();
    }
  
    // 优先级2: meta 标签
    if (!id) {
      const meta = document.querySelector('meta[name="shadowtrace-app-id"]') ||
                   document.querySelector('meta[name="app-id"]');
      if (meta && meta.content) {
        id = meta.content.trim();
      }
    }
  
    // 优先级3: localStorage
    if (!id) {
      try {
        id = localStorage.getItem(STORAGE_KEY_APP_ID);
      } catch (e) {}
    }
  
    // 兜底：生成随机（但最好不要用随机，建议报错）
    if (!id) {
      console.error('[SDK] 无法获取 appId，已使用兜底值 "moveGame"');
      id = 'moveGame';
    }
  
    storeAppId(id);
    return id;
  }

  function storeAppId(id) {
    try {
      localStorage.setItem(STORAGE_KEY_APP_ID, id);
    } catch (e) {}
  }

  // ==================== Core Web Vitals ====================
  function initCoreWebVitals() {
    collectPageLoadMetrics();
    observeLCP();
    observeCLS();
    observeINP();
    observeFID();
  }

  function collectPageLoadMetrics() {
    if (!performance || !performance.timing) return;
    const timing = performance.timing;
    pageLoadTiming = {
      dnsLookup: timing.domainLookupEnd - timing.domainLookupStart,
      tcpConnect: timing.connectEnd - timing.connectStart,
      sslConnect: timing.connectEnd - timing.secureConnectionStart,
      ttfb: timing.responseStart - timing.requestStart,
      downloadTime: timing.responseEnd - timing.responseStart,
      domInteractive: timing.domInteractive - timing.navigationStart,
      domContentLoaded: timing.domContentLoadedEventEnd - timing.navigationStart,
      loadEvent: timing.loadEventEnd - timing.navigationStart,
      redirectCount: performance.navigation.redirectCount,
      type: performance.navigation.type
    };
  }

  function observeLCP() {
    if (!window.PerformanceObserver || !PerformanceObserver.supportedEntryTypes?.includes('largest-contentful-paint')) return;
    try {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const last = entries[entries.length - 1];
        lcpValue = last.renderTime || last.loadTime;
        lcpElement = last.element ? {
          tagName: last.element.tagName,
          id: last.element.id,
          className: last.element.className,
          src: last.element.src || last.element.currentSrc
        } : null;
        lcpUrl = window.location.href;
        saveWebVitalsToStorage('lcp', { value: lcpValue, element: lcpElement, url: lcpUrl, timestamp: Date.now() });
      });
      observer.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) {
      console.error('[Web Vitals] LCP 失败:', e);
    }
  }

  function observeCLS() {
    if (!window.PerformanceObserver || !PerformanceObserver.supportedEntryTypes?.includes('layout-shift')) return;
    try {
      clsObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
            clsSessionValue += entry.value;
            clsEntries.push({
              value: entry.value,
              hadRecentInput: entry.hadRecentInput,
              startTime: entry.startTime,
              timestamp: Date.now()
            });
            if (document.visibilityState === 'hidden') reportCLS();
          }
        }
      });
      clsObserver.observe({ type: 'layout-shift', buffered: true });
    } catch (e) {
      console.error('[Web Vitals] CLS 失败:', e);
    }
  }

  function observeINP() {
    if (!window.PerformanceObserver || !PerformanceObserver.supportedEntryTypes?.includes('event')) {
      observeINPAlternative();
      return;
    }
    try {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'event' && ['click', 'keydown', 'pointerdown'].includes(entry.name)) {
            const delay = entry.processingEnd - entry.startTime;
            inpEntries.push({ name: entry.name, delay, startTime: entry.startTime, target: entry.target });
            if (delay > inpValue) {
              inpValue = delay;
              saveWebVitalsToStorage('inp', { value: inpValue, event: entry.name, timestamp: Date.now() });
            }
          }
        }
      });
      observer.observe({ type: 'event', buffered: true, durationThreshold: 16 });
    } catch (e) {
      observeINPAlternative();
    }
  }

  function observeINPAlternative() {
    let start = 0;
    document.addEventListener('click', () => start = performance.now(), { capture: true, passive: true });
    document.addEventListener('keydown', () => start = performance.now(), { capture: true, passive: true });
    function check() {
      if (start > 0) {
        const delay = performance.now() - start;
        if (delay > inpValue) inpValue = delay;
        start = 0;
      }
      requestAnimationFrame(check);
    }
    check();
  }

  function observeFID() {
    if (!window.PerformanceObserver || !PerformanceObserver.supportedEntryTypes?.includes('first-input')) return;
    try {
      const observer = new PerformanceObserver((list) => {
        const entry = list.getEntries()[0];
        if (entry) {
          fidValue = entry.processingStart - entry.startTime;
          fidEntries.push({ value: fidValue, name: entry.name, startTime: entry.startTime });
          saveWebVitalsToStorage('fid', { value: fidValue, name: entry.name, timestamp: Date.now() });
        }
      });
      observer.observe({ type: 'first-input', buffered: true });
    } catch (e) {}
  }

  function reportCLS() {
    if (clsValue > 0 && !clsReported) {
      saveWebVitalsToStorage('cls', {
        value: clsValue,
        sessionValue: clsSessionValue,
        entries: clsEntries,
        timestamp: Date.now()
      });
      clsReported = true;
    }
  }

  function saveWebVitalsToStorage(type, data) {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY_CORE_WEB_VITALS) || '{}');
      stored[type] = stored[type] || [];
      stored[type].push({ ...data, appId, url: window.location.href, sessionId });
      if (stored[type].length > 10) stored[type] = stored[type].slice(-10);
      localStorage.setItem(STORAGE_KEY_CORE_WEB_VITALS, JSON.stringify(stored));
    } catch (e) {}
  }

  function getCurrentPageWebVitals() {
    return {
      lcp: lcpValue,
      cls: clsValue,
      inp: inpValue,
      fid: fidValue,
      pageLoadTiming,
      url: window.location.href,
      timestamp: Date.now()
    };
  }

  function resetCurrentPageWebVitals() {
    lcpValue = 0; lcpElement = null; lcpUrl = ''; lcpReported = false;
    clsValue = 0; clsSessionValue = 0; clsEntries = []; clsReported = false;
    inpValue = 0; inpEntries = []; inpReported = false;
    fidValue = 0; fidEntries = []; fidReported = false;
    pageLoadTiming = {}; pageLoadEntries = [];
  }

  // ==================== 其他工具函数 ====================
  function getGridKey(clientX, clientY) {
    const w = window.innerWidth || 1;
    const h = window.innerHeight || 1;
    const col = Math.min(Math.floor((clientX / w) * gridCols), gridCols - 1);
    const row = Math.min(Math.floor((clientY / h) * gridRows), gridRows - 1);
    return `${row}-${col}`;
  }

  function incrementGrid(gridObj, key) {
    gridObj[key] = (gridObj[key] || 0) + 1;
  }

  function recordPageView() {
    pvCount++;
    const path = window.location.pathname;
    // if (!paths.includes(path)) paths.push(path);
    paths.push(path);
  }

  function parseUserAgent() {
    const ua = navigator.userAgent;
    let browser = 'Unknown', version = 'Unknown', os = 'Unknown';
    let deviceType = /mobile/i.test(ua) ? 'mobile' : (/tablet/i.test(ua) ? 'tablet' : 'desktop');

    if (/Edg\//i.test(ua)) { browser = 'Edge'; version = ua.match(/Edg\/([\d.]+)/)?.[1] || 'Unknown'; }
    else if (/Chrome\//i.test(ua)) { browser = 'Chrome'; version = ua.match(/Chrome\/([\d.]+)/)?.[1] || 'Unknown'; }
    else if (/Firefox\//i.test(ua)) { browser = 'Firefox'; version = ua.match(/Firefox\/([\d.]+)/)?.[1] || 'Unknown'; }
    else if (/Safari\//i.test(ua) && !/Chrome/i.test(ua)) { browser = 'Safari'; version = ua.match(/Version\/([\d.]+)/)?.[1] || 'Unknown'; }

    if (/Windows/i.test(ua)) os = 'Windows';
    else if (/Mac OS/i.test(ua)) os = 'macOS';
    else if (/Android/i.test(ua)) os = 'Android';
    else if (/iPhone|iPad/i.test(ua)) os = 'iOS';
    else if (/Linux/i.test(ua)) os = 'Linux';

    return { browser, version, os, deviceType };
  }

  function captureBaseInfo() {
    const now = new Date();
    const referrerHost = document.referrer ? new URL(document.referrer).hostname : 'direct';
  
    baseInfo = {
      sessionId,
      appId: appId,
      referrer: referrerHost,
      deviceInfo: parseUserAgent(),
      localTimeInfo: {
        hour: now.getHours(),
        dayOfWeek: now.getDay(),
        month: now.getMonth(),
        year: now.getFullYear()
      },
      timezoneOffset: now.getTimezoneOffset(),
      abTestInfo: { ...abTestInfo },
      pageInfo: {
        url: window.location.href,
        title: document.title,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
      },
      // 关键修改：encryptionInfo.enabled 应该基于会话有效性
      encryptionInfo: {
        enabled: isEncryptionSessionValid(),  // 而不是 encryptionEnabled 变量
        algorithm: encryptionInfo.algorithm,
        sessionId: encryptionInfo.sessionId,
        sessionValid: isEncryptionSessionValid()
      },
      countryInfo: { ...countryInfo },
      botInfo: botDetectionResult || { bot: false, botKind: 'not_detected', botProbability: 0 }
    };
  }

  // ==================== 事件处理 ====================
  function handleVisibilityChange() {
    if (!isRunning) return;
    if (document.hidden) {
      const visibleDuration = (performance.now() - lastVisibleTime) / 1000;
      totalVisibleTime += visibleDuration;
      reportCLS();
    } else {
      lastVisibleTime = performance.now();
      updateLastActiveTime();
    }
  }

  function handleClick(event) {
    if (botDetectionResult?.bot === true || !isRunning) return;
    
    totalClicks++;
    const now = Date.now();
    const timeSinceLastClick = now - lastClickTime;
  
    if (timeSinceLastClick < 100) rapidClicks++;
  
    // 获取点击的网格位置
    const gridKey = getGridKey(event.clientX, event.clientY);
    const row = parseInt(gridKey.split('-')[0]);
    const col = parseInt(gridKey.split('-')[1]);
    
    // 计算实际像素位置
    const w = window.innerWidth || 1;
    const h = window.innerHeight || 1;
    const pixelX = Math.round((col / gridCols) * w);
    const pixelY = Math.round((row / gridRows) * h);
    
    // 详细的点击日志
    console.log('%c[点击网格日志]', 'color: #FF6B6B; font-weight: bold;', {
      时间: new Date().toLocaleTimeString(),
      时间戳: now,
      距离上次点击: `${timeSinceLastClick}ms`,
      
      客户端坐标: {
        x: event.clientX,
        y: event.clientY
      },
      
      页面坐标: {
        x: event.pageX,
        y: event.pageY
      },
      
      屏幕坐标: {
        x: event.screenX,
        y: event.screenY
      },
      
      网格信息: {
        网格键: gridKey,
        行号: row,
        列号: col,
        总行数: gridRows,
        总列数: gridCols
      },
      
      计算位置: {
        像素X: pixelX,
        像素Y: pixelY,
        相对X百分比: Math.round((event.clientX / w) * 100) + '%',
        相对Y百分比: Math.round((event.clientY / h) * 100) + '%'
      },
      
      窗口信息: {
        宽度: w,
        高度: h,
        滚动X: window.scrollX,
        滚动Y: window.scrollY
      },
      
      点击目标: {
        标签名: event.target.tagName,
        ID: event.target.id || '无',
        类名: event.target.className || '无',
        文本: event.target.textContent?.substring(0, 50) || '无'
      },
      
      快速点击: timeSinceLastClick < 100 ? '是' : '否',
      暴击检测: {
        相同网格: gridKey === lastClickGridKey,
        时间间隔: timeSinceLastClick,
        是否暴击: gridKey === lastClickGridKey && timeSinceLastClick < rageThresholdMs
      },
      
      统计信息: {
        总点击数: totalClicks,
        该网格点击次数: (clickGrid[gridKey] || 0) + 1
      }
    });
  
    // 增加网格计数
    incrementGrid(clickGrid, gridKey);
  
    // 暴击点击检测
    if (gridKey === lastClickGridKey && timeSinceLastClick < rageThresholdMs) {
      let rage = rageClicks.find(r => r.gridKey === gridKey);
      if (!rage) {
        rage = { gridKey, count: 1, firstTime: lastClickTime, lastTime: now };
        rageClicks.push(rage);
        console.log('%c[暴击开始]', 'color: #FF0000; font-weight: bold;', `网格 ${gridKey} 开始暴击`);
      } else {
        rage.count++;
        rage.lastTime = now;
        if (rage.count === rageThresholdCount) {
          console.log('%c[暴击达标]', 'color: #FF4500; font-weight: bold;', 
            `网格 ${gridKey} 达到暴击阈值 (${rageThresholdCount}次)`);
        }
      }
    } else {
      lastClickGridKey = gridKey;
    }
  
    lastClickTime = now;
    updateLastActiveTime();
    
    // 显示网格可视化（可选）
    // showClickVisualization(event.clientX, event.clientY, gridKey);
  }
  
  // 可选：添加可视化显示函数
  function showClickVisualization(x, y, gridKey) {
    // 移除之前的可视化
    const existing = document.getElementById('click-visualization');
    if (existing) existing.remove();
    
    const vis = document.createElement('div');
    vis.id = 'click-visualization';
    vis.style.cssText = `
      position: fixed;
      left: ${x - 10}px;
      top: ${y - 10}px;
      width: 20px;
      height: 20px;
      background: rgba(255, 107, 107, 0.7);
      border: 2px solid #FF6B6B;
      border-radius: 50%;
      pointer-events: none;
      z-index: 999999;
      animation: pulse 0.5s ease-out;
    `;
    
    const label = document.createElement('div');
    label.style.cssText = `
      position: absolute;
      top: 25px;
      left: 0;
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 2px 6px;
      border-radius: 3px;
      font-size: 10px;
      white-space: nowrap;
      z-index: 999999;
    `;
    label.textContent = gridKey;
    vis.appendChild(label);
    
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        100% { transform: scale(2); opacity: 0; }
      }
    `;
    
    document.head.appendChild(style);
    document.body.appendChild(vis);
    
    // 3秒后移除
    setTimeout(() => vis.remove(), 3000);
    setTimeout(() => style.remove(), 3000);
  }

  function handleMouseMove(event) {
    if (botDetectionResult?.bot === true || !isRunning) return;
    const now = performance.now();
    if (now - lastMoveTime < moveThrottleMs) return;
    lastMoveTime = now;

    const gridKey = getGridKey(event.clientX, event.clientY);
    incrementGrid(moveGrid, gridKey);

    if (lastMoveX !== null && lastMoveY !== null) {
      const dx = Math.abs(event.clientX - lastMoveX);
      const dy = Math.abs(event.clientY - lastMoveY);
      if (dx === 0 || dy === 0 || Math.abs(dx - dy) < 5) linearMoves++;
    }

    lastMoveX = event.clientX;
    lastMoveY = event.clientY;

    // 节流更新活跃时间
    if (now % 5000 < 100) updateLastActiveTime();
  }

  function handleScroll() {
    if (botDetectionResult?.bot === true || !isRunning) return;
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const winH = window.innerHeight;
    const bodyH = document.body.scrollHeight || document.documentElement.scrollHeight;
    const percent = bodyH > winH ? Math.round((scrollY + winH) / bodyH * 100) : 100;

    if (percent > maxScrollDepth) maxScrollDepth = percent;
    updateLastActiveTime();
  }

  function handleNavigation() {
    if (!isRunning) return;
    reportCLS();
    resetCurrentPageWebVitals();
    recordPageView();
  }

  // ==================== 构建增量事件 ====================
  function buildCurrentIncrement() {
    const visibilityIncrement = (performance.now() - lastVisibleTime) / 1000;
    totalVisibleTime += visibilityIncrement;
    lastVisibleTime = performance.now();

    const heatMapIncrement = {};
    const allKeys = new Set([...Object.keys(clickGrid), ...Object.keys(moveGrid)]);
    allKeys.forEach(k => {
      heatMapIncrement[k] = {
        click: clickGrid[k] || 0,
        move: moveGrid[k] || 0
      };
    });

    const hasData = totalVisibleTime > 1 || totalClicks > 0 || customEvents.length > 0 ||
                    Object.keys(heatMapIncrement).length > 0 || maxScrollDepth > 0 ||
                    pvCount > 0 || rapidClicks > 0 || linearMoves > 0;

    if (hasData) updateLastActiveTime();

    if (!hasData) return null;

    const webVitals = getCurrentPageWebVitals();

    const incrementEvent = {
      type: "increment",
      sessionId,
      appId: appId,
      timestamp: Date.now(),
      browseDurationIncrement: Math.round(totalVisibleTime),
      heatMapIncrement,
      maxScrollDepthUpdate: maxScrollDepth,
      newPvCount: pvCount,
      newPaths: [...paths],
      newClicks: totalClicks,
      newEvents: [...customEvents],
      rapidClicksIncrement: rapidClicks,
      linearMovesIncrement: linearMoves,
      rageClicksUpdate: rageClicks.filter(r => r.count >= rageThresholdCount),
      webVitals
    };

    totalVisibleTime = 0;
    clickGrid = {};
    moveGrid = {};
    customEvents = [];
    totalClicks = 0;
    pvCount = 0;
    rapidClicks = 0;
    linearMoves = 0;
    rageClicks = [];
    resetCurrentPageWebVitals();

    return incrementEvent;
  }

  // ==================== 发送数据 ====================
  async function sendEvents() {
    if (!isRunning || !serverUrl) return;
    
    // ===== 关键：每次发送前检查加密会话 =====
    if (encryptionEnabled) {
      try {
        if (!isEncryptionSessionValid()) {
          console.warn('[加密] 加密会话无效，尝试重新创建');
          const refreshed = await ensureEncryptionSession({ appId: appId });
          if (!refreshed) {
            console.warn('[加密] 无法恢复加密会话，本次发送使用明文');
            encryptionEnabled = false;
          }
        }
      } catch (error) {
        console.error('[加密] 会话检查失败:', error);
      }
    }
    
    // 构建和发送数据
    const lastIncrement = buildCurrentIncrement();
    const eventsToSend = [...eventQueue];
    if (lastIncrement) eventsToSend.push(lastIncrement);
    
    if (eventsToSend.length === 0) return;
    
    const payload = {
      events: eventsToSend,
      appId: appId,
      sdkVersion: '3.0.0',
      timestamp: Date.now()
    };
    
    eventQueue.length = 0;
    
    const encryptedData = await encryptDataForTransmission(payload);
    
    try {
      const endpoint = `${serverUrl}${API_ENDPOINTS.SAVE_DATA}`;
      if (navigator.sendBeacon) {
        const blob = new Blob([encryptedData], { type: 'application/json' });
        navigator.sendBeacon(endpoint, blob);
      } else {
        await fetch(endpoint, {
          method: 'POST',
          body: encryptedData,
          headers: { 'Content-Type': 'application/json' },
          keepalive: true
        });
      }
    } catch (error) {
      console.error('[SDK] 发送失败:', error);
    }
  }

  function startBatchTimer() {
    if (batchInterval) clearInterval(batchInterval);
    batchInterval = setInterval(sendEvents, 60000);
  }

  // ==================== 添加定期检查加密会话的函数 ====================
  function startEncryptionHealthCheck() {
    // 每5分钟检查一次加密会话
    if (window._encryptionHealthCheckInterval) {
      clearInterval(window._encryptionHealthCheckInterval);
    }
    
    window._encryptionHealthCheckInterval = setInterval(() => {
      if (!isRunning || !encryptionEnabled) return;
      
      // 检查主会话是否即将过期
      const lastActive = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
      if (!lastActive) return;
      
      const now = Date.now();
      const lastActiveTime = parseInt(lastActive, 10);
      const timeSinceLastActive = now - lastActiveTime;
      const timeRemaining = SESSION_INACTIVITY_TIMEOUT_MS - timeSinceLastActive;
      
      // 如果主会话即将过期（5分钟内），不续期加密会话
      if (timeRemaining < 5 * 60 * 1000) {
        console.log('[健康检查] 主会话即将过期，不续期加密会话');
        return;
      }
      
      // 检查加密会话是否需要续期
      if (!isEncryptionSessionValid()) {
        console.log('[健康检查] 加密会话无效，准备更新');
        ensureEncryptionSession({ appId: appId }, true) // 强制创建新会话
          .then(success => {
            if (success) {
              console.log('[健康检查] 加密会话更新成功');
            } else {
              console.warn('[健康检查] 加密会话更新失败');
            }
          })
          .catch(err => {
            console.error('[健康检查] 检查加密会话时出错:', err);
          });
      }
    }, 5 * 60 * 1000); // 5分钟
  }



  // ==================== 公开 API ====================
  window.initUserBehaviorSDK = async function (options = {}) {
    console.log('[SDK] 最终 appId:', appId);
    if (isInIframe && (window.location.search.includes('shadowtrace_disable=1') || 
                     window.location.search.includes('analytics_view=1'))) {
      console.log('[SDK] 在分析后台 iframe 中，跳过初始化');
      return;
    }
    serverUrl = 'https://shadowtrace.yingdl.com';
    
    // ==================== 全局唯一初始化判断 ====================
    const initFlagKey = 'shadowtrace_global_init_timestamp';
    const lastInitTimeStr = localStorage.getItem(initFlagKey);
    const now = Date.now();
    const INIT_LOCK_TIMEOUT = SESSION_INACTIVITY_TIMEOUT_MS;
    
    // 检查主会话是否过期
    const lastActive = localStorage.getItem(STORAGE_KEY_LAST_ACTIVE);
    const mainSessionExpired = !lastActive || (now - parseInt(lastActive, 10) > SESSION_INACTIVITY_TIMEOUT_MS);
    
    // 如果主会话已过期，必须执行完整初始化
    if (mainSessionExpired) {
      console.log('[SDK] 主会话已过期，执行完整初始化');
      // 清除之前的初始化标记
      localStorage.removeItem(initFlagKey);
    }
    
    // 如果近期已完成完整初始化且主会话未过期，则进入"复用模式"
    if (!mainSessionExpired && lastInitTimeStr && (now - parseInt(lastInitTimeStr, 10) < INIT_LOCK_TIMEOUT)) {
      console.log('[SDK] 检测到近期已全局初始化，进入复用模式');
      
      // 加载主 sessionId
      sessionId = getPersistentSessionId(); // 这会复用现有session或创建新session
      
      // 强制开启加密
      encryptionEnabled = true;
      
      appId = getAppId(options);
      
      // 复用模式下确保加密会话有效
      const encryptionReady = await ensureEncryptionSession(options, false); // 不强制创建
      if (!encryptionReady) {
        console.warn('[SDK] 复用模式下加密会话无效，将继续以明文模式运行');
        encryptionEnabled = false;
      }
      
      // 当前页面轻量处理
      recordPageView();
      captureBaseInfo();
      
      // 上报 page_view
      eventQueue.push({
        type: "page_view",
        path: window.location.pathname,
        title: document.title,
        referrer: document.referrer || '',
        timestamp: Date.now()
      });
      
      // 确保批量发送定时器在运行
      if (!batchInterval) {
        startBatchTimer();
      }
      
      // 启动加密会话健康检查
      if (encryptionEnabled) {
        startEncryptionHealthCheck();
      }
      
      // 标记运行状态
      isRunning = true;
      
      console.log('[SDK] 复用模式完成，当前 sessionId:', sessionId);
      return;
    }
    
    // ==================== 首次或已过期 → 执行完整初始化流程 ====================
    console.log('[SDK] 执行完整 SDK 初始化（首次或过期）');
    
    // 清除旧的初始化标记
    localStorage.removeItem(initFlagKey);
    
    // 基础数据采集
    fetchCountryInfo();
    if (BOT_DETECTION_ENABLED) detectBot();
    
    // 配置参数
    serverUrl = options.serverUrl || AUTO_INIT_CONFIG.serverUrl;
    gridRows = options.gridRows || 10;
    gridCols = options.gridCols || 10;
    
    appId = getAppId(options);
    if (!appId) {
      console.error('[SDK] 应用ID未配置，SDK初始化失败');
      return;
    }
    
    // 强制开启加密
    encryptionEnabled = true;
    
    // 获取 sessionId（内部会检查是否过期，过期会创建新session）
    sessionId = getPersistentSessionId();
    
    // 处理加密会话 - 强制创建新会话
    const encryptionReady = await ensureEncryptionSession(options, true);
    if (!encryptionReady) {
      console.warn('[SDK] 加密初始化失败，将继续以明文模式运行');
      encryptionEnabled = false;
    }
    
    // 加载或重新计算归因
    if (!loadAttribution()) {
      const params = getUrlParams();
      const referrerFull = document.referrer;
      const referrerDomain = referrerFull ? new URL(referrerFull).hostname.replace(/^www\./, '') : null;
      
      attributionInfo.referrerDomain = referrerDomain;
      attributionInfo.source = params.utm_source || '(not set)';
      attributionInfo.medium = params.utm_medium || '(not set)';
      attributionInfo.campaign = params.utm_campaign || '(not set)';
      attributionInfo.content = params.utm_content || null;
      attributionInfo.term = params.utm_term || null;
      
      const extractedKeyword = extractSearchKeyword();
      if (extractedKeyword && !attributionInfo.term) {
        attributionInfo.term = extractedKeyword;
        attributionInfo.termSource = 'referrer';
      } else if (extractedKeyword && attributionInfo.term) {
        attributionInfo.termFallback = extractedKeyword;
      }
      
      const classified = classifyChannel(params, referrerDomain);
      attributionInfo.channel = classified.channel;
      attributionInfo.sourceType = classified.sourceType || attributionInfo.source;
      attributionInfo.socialPlatform = classified.socialPlatform || null;
      
      saveAttribution();
    }
    
    // 重置当前页面相关计数器和状态
    totalVisibleTime = 0;
    lastVisibleTime = performance.now();
    clickGrid = {};
    moveGrid = {};
    maxScrollDepth = 0;
    rageClicks = [];
    pvCount = 0;
    paths = [];
    totalClicks = 0;
    customEvents = [];
    rapidClicks = 0;
    linearMoves = 0;
    
    resetCurrentPageWebVitals();
    recordPageView();
    
    captureBaseInfo();
    baseInfo.attribution = { ...attributionInfo };
    
    // 完整初始化时才上报 session_start
    eventQueue.push({
      type: "session_start",
      ...baseInfo,
      timestamp: Date.now()
    });
    
    // 绑定事件监听（只在第一次完整初始化时绑定）
    if (!isRunning) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
      document.addEventListener('click', handleClick);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('popstate', handleNavigation);
      window.addEventListener('hashchange', handleNavigation);
      window.addEventListener('beforeunload', sendEvents);
      window.addEventListener('pagehide', sendEvents);
      
      initCoreWebVitals();
    }
    
    isRunning = true;
    startBatchTimer();
    
    // 启动加密会话健康检查
    if (encryptionEnabled) {
      startEncryptionHealthCheck();
    }
    
    // 标记本次完整初始化完成
    localStorage.setItem(initFlagKey, now.toString());
    
    console.log('[SDK] 完整初始化完成，sessionId:', sessionId);
  };

  window.trackEvent = function (name, props = {}) {
    if (!isRunning) return;
    customEvents.push({
      name,
      props,
      timestamp: Date.now(),
      pagePath: window.location.pathname,
      appId
    });
  };

  window.setABTest = function (obj = {}) {
    if (!isRunning) return;
    Object.assign(abTestInfo, obj);
  };

  window.optOutUserBehaviorSDK = function () {
    isRunning = false;
    if (batchInterval) clearInterval(batchInterval);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    document.removeEventListener('click', handleClick);
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('scroll', handleScroll);
    window.removeEventListener('popstate', handleNavigation);
    window.removeEventListener('hashchange', handleNavigation);
    window.removeEventListener('beforeunload', sendEvents);
    window.removeEventListener('pagehide', sendEvents);
    if (clsObserver) {
      clsObserver.disconnect();
      clsObserver = null;
    }
    reportCLS();
    console.warn('[SDK] 已退出数据收集');
  };

  window.optInUserBehaviorSDK = async function () {
    if (isRunning) return;
    isRunning = true;
    sessionId = getPersistentSessionId();
    if (encryptionEnabled) await initializeEncryption({ appId });
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('click', handleClick);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('popstate', handleNavigation);
    window.addEventListener('hashchange', handleNavigation);
    window.addEventListener('beforeunload', sendEvents);
    window.addEventListener('pagehide', sendEvents);
    initCoreWebVitals();
    startBatchTimer();
  };

  window.forceSendSDKData = async function () {
    if (isRunning) await sendEvents();
  };

  window.getWebVitalsStatus = function() {
    return {
      lcp: { value: lcpValue + 'ms', element: lcpElement, reported: lcpReported },
      cls: { value: clsValue.toFixed(4), sessionValue: clsSessionValue.toFixed(4), entries: clsEntries.length, reported: clsReported },
      inp: { value: inpValue + 'ms', entries: inpEntries.length, reported: inpReported },
      fid: { value: fidValue + 'ms', entries: fidEntries.length, reported: fidReported },
      pageLoadTiming,
      currentPage: window.location.href,
      appId,
      sessionId
    };
  };

  window.getEncryptionStatus = function() {
    return {
      enabled: encryptionEnabled,
      sessionValid: isEncryptionSessionValid(),
      sessionId: encryptionInfo.sessionId,
      sessionExpiry: encryptionInfo.sessionExpiry,
      aesKey: encryptionInfo.aesKey ? encryptionInfo.aesKey.substring(0, 20) + '...' : '未设置',
      aesIv: encryptionInfo.aesIv,
      rsaPublicKey: encryptionInfo.rsaPublicKey ? encryptionInfo.rsaPublicKey.substring(0, 20) + '...' : '未设置',
      encryptedAesKey: encryptionInfo.encryptedAesKey ? encryptionInfo.encryptedAesKey.substring(0, 20) + '...' : '未设置',
      algorithm: encryptionInfo.algorithm,
      appId
    };
  };

  // ==================== 自动初始化 ====================
  async function autoInitializeSDK() {
    if (!AUTO_INIT) return;
    setTimeout(async () => {
      const config = { ...AUTO_INIT_CONFIG };
      const appIdMeta = document.querySelector('meta[name="shadowtrace-app-id"]') ||
                        document.querySelector('meta[name="app-id"]');
      if (appIdMeta && appIdMeta.content) {
        config.appId = appIdMeta.content.trim();
      }
      await window.initUserBehaviorSDK(config);
    }, INIT_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitializeSDK);
  } else {
    autoInitializeSDK();
  }

  console.log('%c[SDK] ShadowTrace SDK 加载完成（session 30min 无活动过期）', 'color: limegreen; font-weight: bold;');
})();

window.safeInitShadowTrace = function (options = {}) {
  if (typeof window.initUserBehaviorSDK === 'function') {
    window.initUserBehaviorSDK(options);
  } else {
    window.__shadowTracePendingInit = options;
  }
};